import {Component, OnInit} from '@angular/core';
import {
  QuarantinePlacementFormComponent
} from "@app/quarantine/quarantine-placement-form/quarantine-placement-form.component";
import {QuarantinePlacementFormInterface} from "@app/quarantine/intrfaces/quarantine.interface";
import {ActivatedRoute} from "@angular/router";
import {DataService} from "@app/shared/data.service";

@Component({
  selector: 'app-create-quarantine-removal',
  templateUrl: './create-quarantine-removal.component.html',
  styleUrls: ['./create-quarantine-removal.component.scss'],
  standalone: true,
  imports: [
    QuarantinePlacementFormComponent
  ]
})
export class CreateQuarantineRemovalComponent implements OnInit{
  config: QuarantinePlacementFormInterface = {
    documentType: 'QUARANTINE_REMOVAL',
    stage: "CREATE",
  }
  
  constructor(
      private activatedRoute: ActivatedRoute,
      private dataService: DataService
  ) {
  }
  
  ngOnInit() {
    let breadcrumbs =  [...this.activatedRoute.snapshot.data['breadcrumbs']]
    breadcrumbs.push({title: 'Створити зняття з карантину', link: ''});
    
    this.dataService.breadcrumbsArray.next(breadcrumbs)
  }
  
}
